
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      let d = window.wf.ProductStcs;
      d.specifiedproducts ??= [];
      d.selectedProduct ??= '';
      d.detailurl ??= '';
      return d;
    },
    beforeMount() {
      this.getProductsJson();
      this.updateStcs();
    },
    methods: {
      dealerNameAndLink(stc) {
        var tempDealerNameAndLink = "";
        if (stc.dealers.length > 0) {
            var dealer = stc.dealers[0];
            tempDealerNameAndLink = dealer.name;
          if (!dealer.exclude_from_navigation && dealer.contentItemId != null) {
            tempDealerNameAndLink = '<a href="' + this.detailurl + '/' + dealer.contentItemName + '">' + tempDealerNameAndLink + '</a>';
          }
        }
        return tempDealerNameAndLink;
      },
      getProductsJson() {
        fetch("/webapi/stcsapi/products")
          .then(response => response.json())
          .then(json => {
            this.products = json;
          });
      },
      updateStcs() {
        fetch("/webapi/stcsapi/stcs", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.selectedProduct),
        })
          .then(response => response.json())
          .then(json => {
            this.stcs = json;
          });
      }
    },
    computed: {
      productStcs() {
        return this.stcs.filter((stc) => {
          return stc.product.toLowerCase() === (this.selectedProduct.toLowerCase());
        });
      },
      orderedAircraftMakes() {
        var tempOrderedAircraftMakes = this.productStcs.map(d => d.aircraft_make);
        tempOrderedAircraftMakes = tempOrderedAircraftMakes.filter((value, index, self) => self.indexOf(value) === index);
        return tempOrderedAircraftMakes.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      },
      filteredProducts() {
        if (this.specifiedproducts.length === 0) {
          return this.products;
        }
        var tempFilteredProductNames = this.specifiedproducts.map(sp => sp.product);
        // return this.products;
        var tempFilteredProducts = this.products.filter((product) => {
          return tempFilteredProductNames.includes(product.name);
        });
        if (tempFilteredProducts.length === 1) {
          this.selectedProduct = tempFilteredProducts[0].name;
          this.updateStcs();
        }
        return tempFilteredProducts;
      }
    }
  }

